import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { SvgSprite } from 'modules/svgSprite';

// #region Styles

const ClickArea = styled.span<{ validationState: boolean }>`
    cursor: pointer;
    position: absolute;
    width: 30px;
    height: 20px;
    ${({ validationState }) =>
        validationState
            ? css`
                  right: 10px;
              `
            : css`
                  right: 33px;
              `}
    transform: translateY(-50%);
    top: 50%;
`;

const EyeIcon = styled(SvgSprite)`
    width: 100%;
    height: 100%;
`;

// #endregion Styles

interface IProps {
    inputRef: React.MutableRefObject<any>;
    validationState: boolean;
}

const InputToggle = ({ inputRef, validationState = true }: IProps) => {
    const [passwordShown, setPasswordShown] = useState<boolean>(false);

    const togglePassword = () => {
        setPasswordShown((oldState) => {
            if (oldState === false) {
                inputRef.current.type = 'text';
                return true;
            }
            inputRef.current.type = 'password';
            return false;
        });
    };

    return (
        <ClickArea onClick={togglePassword} validationState={validationState}>
            <EyeIcon sprite={passwordShown ? 'EyeSlash' : 'Eye'} />
        </ClickArea>
    );
};

export default InputToggle;
